export enum RolesType {
    EMPRESAS = 'empresa',
    CANDIDATOS = 'candidato',
    ADMIN = 'admin'
}
